import { IChart } from '@interfaces/kpi/kpiCommon';
import { IGroupSelectOptions } from '@components/common/GroupSelectKpi/GroupSelect.types';

import { EVendorsValues } from '@enums/common';

export interface IKpiListInterface {
	[key: string]: Array<{
		chart: IChart;
		id: string;
		title: string;
	}>;
}

const createKpiMap = (options: IGroupSelectOptions[]): Map<string, any> => {
	return new Map(
		options.flatMap((option) => option.categoryGroups.flatMap((categoryGroup) => {
			return categoryGroup.items.map((item) => {
				return [item.id, { categoryTitle: categoryGroup.category.title, kpi: item }];
			});
		})),
	);
};

export const getListOfKpis = (
	charts: IChart[],
	optionsLimenetKpi: IGroupSelectOptions[],
	optionsNokiaKpi: IGroupSelectOptions[],
): IKpiListInterface => {
	const list: IKpiListInterface = {};

	const limenetKpiMap = createKpiMap(optionsLimenetKpi);
	const nokiaKpiMap = createKpiMap(optionsNokiaKpi);

	for (const chart of charts) {
		const kpiMap = chart.vendor.name === EVendorsValues.limenet
			? limenetKpiMap
			: nokiaKpiMap;
		const kpiData = kpiMap.get(chart.kpiId);

		if (kpiData) {
			const kpiChart = { ...kpiData.kpi, chart };
			const categoryTitle = kpiData.categoryTitle;

			if (!list[categoryTitle]) {
				list[categoryTitle] = [];
			}

			list[categoryTitle].push(kpiChart);
		}
	}

	return list;
};

